import React, { useEffect, useRef, useState, FC } from 'react'
import { Button, Form, message, Modal, Upload } from 'antd'
import { YhFormBox } from '@/components/YhFormBox'
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef, ISelectOption } from '@/components/YhFormBox/Types'
import useNavModel, { RouterParamType } from '@/model/navModel'
import { getFormValidatorErrText, switchNum1, formatNum } from '@/utils/utils'
import { ITreeSelectData, useDictModel } from '@/views/base/dict/dictModel'
import { useAssetsAbandonDetailsModel } from './assetsAbandonDetailsModel'
import { ISCMAssetsAbandonFormFields } from '../../assetsAbandonTypes'
import useGlobalModel from '@/model/globalModel'
import { YhAuth } from '@/components/auth/YhAuth'
import { debounce } from 'lodash'
import { assetsAbandonService } from '../../assetsAbandonService'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import FontIcon from '@/components/YhIcon'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from '@/utils/constants'
import { UploadOutlined } from '@ant-design/icons'
import { UploadChangeParam } from 'antd/lib/upload'
import { fileDownload } from '@/utils/exportFile'
import { UploadFile } from 'antd/lib/upload/interface'
import { YHDetailNav } from '@/components/YHDetailNav'
import { useOrgModel } from '@/views/base/organization/orgModel'
import { globalPrompt } from '@/components/message'
import { applyListService } from '@/views/apply/applyList/applyListService'
import { Image } from 'antd';

export const FormBox: FC<RouterParamType> = ({ id, mode }) => {
    const formRef = useRef<IYhFormRef>()
    const {
        editFormVal,
        addFormVal,
        buttonControl,
        saveBtnLoading,
        saveBtn,
        applyList, 
        setApplyList,
        setPrint,
        insertSDc,
        updateSDc,
        getSDcDetailOne,
        updateEditFormVal,
        updateAddFormVal,
        resetEditCatch,
        resetAddCatch,
        verifyGoods,
        setSaveBtnLoading,
        setAddGoodsList,
        addGoodsList
    } = useAssetsAbandonDetailsModel()
    const { selectedNavId, replaceNav, findNav } = useNavModel()
    const { getSelectedDictOne } = useDictModel(() => [])
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const [departmentList, setDepartmentList] = useState<any>([]);
    const formData= mode === "edit" ?editFormVal:addFormVal;

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav('2-4-1') && resetAddCatch()
            !findNav('2-4-2') && resetEditCatch()
        }
    }, [selectedNavId])

    //编辑时， 没有缓在调用详情接口    //回显对应门店核算单位的实体
    useEffect(() => {
        if (mode !== 'add') {
                getSDcDetailOne(id)
                return
        }
    }, [mode])
    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }, isFormItem: boolean = true) => {
        mode === 'edit' ? updateEditFormVal(val) : updateAddFormVal(val)
    }

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: any) => {
        if(changedValues['typeCode']){
            setAddGoodsList([])
            saveCache(changedValues)
        }else if(changedValues['applyCode']){
            saveCache({ note:applyList.find((item) => item.value === changedValues['applyCode'])?.name ?? ''})
        }else{
        saveCache(changedValues)
        }
    }
    const focusApplyCode = async () => {
        if (!(mode === 'add' ?addFormVal.department: editFormVal.department)) {
            globalPrompt('message', { text: '请先选择所属部门哦！', type: 'warning' })
            return
        }
        const searchParams = {
            isUse:0,
            department:mode === 'add'?addFormVal.department: editFormVal.department,
            status: "assets-apply-status.pass",
            pageSize: 50,
            pageNum: 1,
            typeCode:'assets-apply-type.discard'
        }
        let { retData } = await applyListService.page(searchParams);
        const { records, ...pg } = retData;
        let option=records.map((item)=>{
            return{
                label:item.code+'('+item.supplierName+')',
                value:item.code,
                name:item.supplierName,
            }
        })
        setApplyList(option);    
    }
    //机构选中
    const onCompanyChange = (value: string, node: ITreeSelectData) => {
        setDepartmentList([node])
        node && saveCache({ companyName: node.title,company: node.value, department:'',departmentName:''})
        if(addGoodsList.length>0){
            setAddGoodsList([])
        }
    }
    //机构选中
    const onDepartmentChange = (value: string, node: ITreeSelectData) => {
        node && saveCache({ departmentName: node.title,department: node.value, })
        if(addGoodsList.length>0){
            setAddGoodsList([])
        }
    }
    //表单提交
    const onSubmit = () => {
        if (formData.typeCode!=='assets-discard.preturn'&&!verifyGoods(mode)) return
        formRef.current
            ?.validateFields()
            .then((val: any) => {
                const { fileList = [] } = val
                if (fileList.length > 0) {
                    const file = fileList[0]
                    if (!file?.uid) {
                        return message.error('文件信息有误，请重新上传文件')
                    }
                    val.md5 = file?.uid
                    val.fileName = file?.name
                } else {
                    val.md5 = ''
                    val.fileName = ''
                }
                val.typeName = val.typeCode?getSelectedDictOne(DictCodeEnmu.ASSETS_DISCARD).find(item=>item.value==val.typeCode)?.label:''

                val.fileList = null
                mode === 'edit'
                    ? updateSDc(val)
                    : insertSDc(val).then((res) => {
                          if (res) {
                              replaceNav(selectedNavId, '2-4')
                              setSaveBtnLoading(false)
                          }
                      })
            })
            .catch((err) => {
                message.warning(getFormValidatorErrText(err))
            })
    }

    const action = (
        <>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_S_C_ED_SAVE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                loading={saveBtnLoading}
                onClick={debounce(() => {
                    onSubmit()
                }, 500)}
                disabled={mode=='look'}
            >
                {saveBtnLoading ? '保存中' : '保存'}
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_C_ED_BACK}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    replaceNav(selectedNavId, '2-4')
                    setSaveBtnLoading(false)
                }}
            >
                返回
            </Button>
            </YhAuth>
        </>
    )

    const normFile = (e: UploadChangeParam) => {
        if (e?.file.status === 'done') {
            if (e?.file.response.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e.file.response.retData,
                }
                e.fileList = [data]
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }

    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { padding: '10px 0 0 0', marginBottom: '15px' },
        contentClass: 'pr-77',
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报废单号',
                fieldName: 'code',
                disable: true,
                placeholder: '自动生成',
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '报废类型',
                fieldName: 'typeCode',
                options: getSelectedDictOne(DictCodeEnmu.ASSETS_DISCARD).map((item)=>{return{...item,disabled:item.value=='assets-discard.discard'?true:false}}),
                rules: [{ required: true, message: '请选择报废类型' }],
            },
            {
                type:mode=='add'?FormItemTypeEnum.TreeSelect:FormItemTypeEnum.Input,
                fieldLabel: '所属公司',
                fieldName: mode=='add'?'company':'companyName',
                onTreeSelectChange:onCompanyChange,
                hidden:addFormVal.typeCode=='assets-discard.preturn',
                treeData: getOrgTreeSelect(DictCodeEnmu.ORG),
                rules: [{ required:addFormVal.typeCode=='assets-discard.preturn'?false:true, message: '请选择从属机构' }],
            },
            {
                type:mode=='add'?FormItemTypeEnum.TreeSelect:FormItemTypeEnum.Input,
                fieldLabel: '所属部门',
                fieldName: mode=='add'?'department':'departmentName',
                onTreeSelectChange:onDepartmentChange,
                hidden:addFormVal.typeCode=='assets-discard.preturn',
                // treeData: getOrgTreeSelect(DictCodeEnmu.ORG),
                treeData:departmentList.length>0?departmentList: getOrgTreeSelect(DictCodeEnmu.ORG),
                rules: [{ required:addFormVal.typeCode=='assets-discard.preturn'?false:true, message: '请选择领用部门' }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '申请单号',
                fieldName: 'applyCode',
                options: applyList,
                onSelectFocus:focusApplyCode,
                rules: [{ required: addFormVal.typeCode=='assets-discard.discard'?true:false, message: '请选择申请单号' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报废说明',
                fieldName: 'note',
                labelCol:{ span: 3 },
                span:12
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报废名称',
                fieldName: 'cancelName',
                disable:addFormVal.typeCode!=='assets-discard.preturn',
                rules: [{ required:addFormVal.typeCode!=='assets-discard.preturn'?false:true, message: '请选择领用部门' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '实体',
                fieldName: 'bentityName',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报废员',
                fieldName: 'createUser',
                disable: true,
                placeholder: '自动生成',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报废时间',
                fieldName: 'createTime',
                disable: true,
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '附件',
                fieldName: 'inMd5',
                colClassName: 'ant-col-h-auto',
                span: 12,
                formItem: (
                    <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
                        <Upload
                            onPreview={onPreview}
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            listType="picture"
                            beforeUpload={(file) => {
                                let fileEnd: string = file.name.substring(file.name.lastIndexOf("."));
                                let filetypes: string[] = [".jpg", ".png", ".jpeg", "svg", ".gif"];
                                let isType = filetypes?.includes(fileEnd);
                                // if (!isType) {
                                //     message.error('不支持该格式的上传,当前仅支持.jpg", ".png", ".jpeg", "svg", ".gif"类型文件');
                                // }
                                const isLt20M = file.size / 1024 / 1024 < 20
                                if (!isLt20M) {
                                    message.error('上传到文件不能超过20M')
                                }
                                // return isType && isLt20M
                                return isLt20M
                            }}
                            iconRender={(file) => {
                                return (
                                    <FontIcon
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                        style={{ fontSize: '24px' }}
                                        type="icon-tupian"
                                    />
                                )
                            }}
                        >
                            <Button icon={<UploadOutlined />}>选择文件上传</Button>
                        </Upload>
                    </Form.Item>
                ),
            },
            // 带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入实体名称',
                fieldName: 'departmentName',
                hidden: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '调入实体名称',
                fieldName: 'companyName',
                hidden: true,
            },
        ],
    }

    const poFromConfig: IYhFormBox<ISCMAssetsAbandonFormFields> = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: 'right',
        formValues: mode === 'add' ?addFormVal: editFormVal,
        onChange,
        boxs: [baseFormItem],
        disabled:mode=='look'
    }

    return (
        <>
            <YHDetailNav title={`${mode === 'edit' ? '编辑' :mode === 'look'?'查看': '新增'}`} btns={action} style={{ marginBottom: '8px' }} />
            <YhFormBox {...poFromConfig} />
        </>
    )
}
